import { StyleSheet } from 'react-native'
import Identity from '../../../utils/Identity'

export const useCustomDrawerStyles = (theme, isTablet) => StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: isTablet ? theme.WHITE : '#000'
  },
  largeContainer: {
    ...Identity.Shadow(theme).Card,
    maxWidth: 100,
    borderRightWidth: 0
  },
  header: {
    height: 290
  },
  closeIconContainer: {
    marginTop: 20,
    alignItems: 'flex-start'
  },
  closeIcon: {
    margin: 10,
    padding: 10
  },
  logoContainer: {
    flex: 1,
    alignItems: 'center',
    marginTop: 40
  },
  logo: {
    width: 240,
    height: 55
  },
  menu: {
    backgroundColor: theme.WHITE
  },
  logoutContainer: {
    backgroundColor: theme.WHITE
  },
  divider: {
    marginVertical: 20
  },
  photo: {
    height: 70,
    width: '100%',
    justifyContent: 'center',
    alignContent: 'center',
    marginBottom: 20
  }
})

export const useTopbarStyles = (theme, isDesktop, isDemo) => StyleSheet.create({
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingHorizontal: 20,
    paddingVertical: 5,
    minHeight: 40,
    zIndex: 2
  },
  title: {
    flexDirection: 'row',
    alignItems: 'center'
  },
  rightItems: {
    flexDirection: 'row',
    alignItems: 'center'
  },
  detailsLarge: {
    flexDirection: 'row',
    position: 'absolute',
    right: 0,
    top: 0,
    width: isDesktop && isDemo ? 510 : 310,
    alignItems: isDemo ? 'flex-end' : 'center'
  },
  buttonsContainer: {
    flexDirection: isDesktop ? 'row' : !isDemo ? 'row' : 'column',
    width: isDesktop ? 'auto' : 190,
    alignItems: 'center'
  },
  hotOffer: {
    marginRight: 20,
    marginTop: 0
  },
  hotOfferLarge: {
    marginRight: isDesktop ? 30 : 0,
    marginBottom: isDesktop ? isDemo ? 6 : 0 : 20,
    marginTop: !isDemo && isDesktop ? 6 : 0,
    padding: 15,
    backgroundColor: theme.FERN,
    borderRadius: 5,
    flexDirection: 'row',
    height: 30,
    alignItems: 'center'
  },
  requestAccessLarge: {
    marginRight: isDesktop ? 10 : 0,
    marginBottom: 6,
    padding: 15,
    backgroundColor: theme.BUNKER,
    borderRadius: 5,
    flexDirection: 'row',
    height: 30,
    alignItems: 'center'
  },
  hotOfferDot: {
    position: 'absolute',
    right: 2,
    top: 0,
    height: 8,
    width: 8,
    borderRadius: 50,
    backgroundColor: theme.RED_ORANGE,
    zIndex: 2
  },
  hotOfferDotLarge: {
    position: 'absolute',
    right: -5,
    top: -5,
    borderRadius: 50,
    backgroundColor: theme.RED_ORANGE,
    zIndex: 2,
    paddingHorizontal: 5
  },
  logo: {
    height: 50,
    width: 150,
    backgroundColor: theme.WHITE,
    alignSelf: 'center',
    marginLeft: 'auto',
    marginBottom: isDesktop ? 0 : 30
  }
})

export const useMainContainerStyles = (theme) => StyleSheet.create({
  safeAreaContainer: {
    flex: 1
  },
  container: {
    flex: 1,
    width: '100%',
    marginLeft: 'auto',
    margin: 'auto'
  },
  content: {
    flex: 1,
    width: '100%',
    maxWidth: 1000,
    margin: 'auto'
  },
  alertMessage: {
    backgroundColor: theme.SAFFRON,
    width: '100%',
    padding: 10
  }
})
